import React, { Suspense, lazy } from 'react';

import CircularLoader from 'components/Loader/CircularLoader';

const Auth = lazy(() => import('./auth'));
const Administrator = lazy(() => import('./administrator'));
const College = lazy(() => import('./college'));
const HR = lazy(() => import('./hr'));
const InactiveStudent = lazy(() => import('./inactiveStudent'));
const Pro = lazy(() => import('./pro'));
const Student = lazy(() => import('./student'));
const Association = lazy(() => import('./association'));

const getRoutes = (type) => {
  switch (type) {
    case 'administrator':
      return <Administrator />;
    case 'association':
      return <Association />;
    case 'college':
      return <College />;
    case 'hr':
      return <HR />;
    case 'inactiveStudent':
      return <InactiveStudent />;
    case 'pro':
      return <Pro />;
    case 'student':
      return <Student />;
    default:
      return <Auth />;
  }
};

const loadableRoutes = (type) => <Suspense fallback={<CircularLoader />}>{getRoutes(type)}</Suspense>;

export default loadableRoutes;
